module.exports = __webpack_public_path__ + "img/banner2026_th.f8bb7fe2.webp";